import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, tap, throwError } from 'rxjs';

import { BAAS_TELEMETRY } from '../constants/tokens.constants';

export function baasTelemetryInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    const telemetry = inject(BAAS_TELEMETRY);

    const transaction = telemetry.startTransaction(`NG HTTP ${req.method} ${req.url}`, 'ng-http-client');
    const httpSpan = transaction.startSpan('Invoking http call with Angular HttpClient', 'ng-apm-interceptor');

    const end = () => {
        httpSpan?.end();
        transaction.end();
    };
    return next(req).pipe(
        tap(() => {
            end();
        }),
        catchError((error) => {
            telemetry.handleError(error);
            end();
            return throwError(() => error);
        })
    );
}
